import { apiSlice } from "../slices/apiSlice";
export const attendanceAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* ===================== CHECK IN ===================== */
    checkIn: builder.mutation({
      query: (body) => ({
        url: "/api/v1/attendance/checkin",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Attendance", "TodayAttendance"],
    }),
    /* ===================== CHECK OUT ===================== */
    checkOut: builder.mutation({
      query: (body) => ({
        url: "/api/v1/attendance/checkout",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Attendance", "TodayAttendance"],
    }),
    /* ===================== GET ALL RECORDS ===================== */
    getAllAttendanceRecords: builder.query({
      query: () => "/api/v1/attendance/records",
      providesTags: ["Attendance"],
    }),

    /* ========================GET RECORDS BY ROLE ===============*/

    getRecordsByRole: builder.query({
      query: ({ page = 0, size = 10, filter, sortBy, sortDir }) => ({
        url: `/api/v1/attendance/records`,
        method: "POST",
        params: {
          page,
          size,
          sort: `${sortBy},${sortDir}`,
        },

        body: filter,
      }),

      providesTags: ["Attendance"],

      keepUnusedDataFor: 0,
    }),
    // =============== Hr records ========================== //
    getHrAttendanceRecords: builder.query({
      query: ({
        page = 0,
        size = 10,
        sortBy = "checkInTime",
        sortDir = "desc",
        filter,
      }) => ({
        url: "/api/v1/attendance/records",
        method: "POST",
        params: {
          page,
          size,
          sort: `${sortBy},${sortDir}`,
        },
        body: filter,
      }),

      transformResponse: (response) => ({
        content: response.content || [],
        totalPages: response.totalPages || 0,
        totalElements: response.totalElements || 0,
        currentPage: response.number || 0,
        pageSize: response.size || 10,
      }),

      providesTags: ["Attendance"],
      keepUnusedDataFor: 0,
    }),
    /* ===================== FILTERED RECORDS ===================== */
    getAttendanceRecordsWithFilter: builder.query({
      query: ({
        page = 0,
        size = 20,
        sortBy = "checkInTime",
        sortDir = "desc",
        employeeName,
        fromDate,
        toDate,
        status,
      }) => ({
        url: "/api/v1/attendance/records/filter",
        params: {
          page,
          size,
          sort: sortBy
            ? `${sortBy},${sortDir || "asc"}`
            : undefined,
          employeeName,
          fromDate,
          toDate,
          status,
        },
      }),
      transformResponse: (response) => ({
        data: response.content || [],
        totalPages: response.totalPages || 0,
        totalElements: response.totalElements || 0,
        currentPage: response.number || 0,
        pageSize: response.size || 20,
      }),
      providesTags: ["Attendance"],
    }),
    /* ===================== PENDING RECORDS ===================== */
    getPendingAttendanceRecords: builder.query({
      query: () => ({
        url: "/api/v1/attendance/records/pending",
      }),
      providesTags: ["Attendance"],
    }),
    /* ===================== GET BY USER ID ===================== */
    // getAttendanceByUserID: builder.query({
    //   query: ({ userID, page = 0, size = 1000 }) => ({
    //     url: `/api/v1/attendance/records/employees/${userID}`,
    //     params: { page, size },
    //   }),
    //   providesTags: ["Attendance"],
    // }),
    getAttendanceByUserID: builder.query({
      query: ({
        userID,
        page = 0,
        size = 10,
        sortBy = "checkInTime",
        sortDir = "desc",
        employeeName,
        fromDate,
        toDate,
        status,
      }) => ({
        url: `/api/v1/attendance/records/employees/${userID}`,
        params: {
          page,
          size,
          sort: `${sortBy},${sortDir}`,
          employeeName: employeeName || undefined,
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,
          status: status || undefined,
        },
      }),

      transformResponse: (response) => ({
        content: response.content || [],
        totalPages: response.totalPages || 0,
        totalElements: response.totalElements || 0,
        currentPage: response.number || 0,
        pageSize: response.size || 10,
      }),

      providesTags: ["Attendance"],
    }),
    /* ===================== MISSed CHECKOUT ALERT ===================== */
    getMissedCheckoutAlert: builder.query({
      query: (userID) =>
        `/api/v1/attendance/records/employees/${userID}/missed-checkout-alert`,
      providesTags: ["TodayAttendance"],
    }),
    /* ===================== GET BY USER + DATE ===================== */
    getAttendanceByUserIDAndDate: builder.query({
      query: ({ userID, date }) =>
        `/api/v1/attendance/records/employees/${userID}/date?date=${date}`,
      providesTags: ["TodayAttendance"],
    }),
    /* ===================== REVIEW ATTENDANCE ===================== */
    reviewAttendance: builder.mutation({
      query: (body) => ({
        url: "/api/v1/attendance/records/review",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Attendance", "TodayAttendance"],
    }),

    /* ===================== BULK APPROVE / REJECT ===================== */
    bulkApproveAttendance: builder.mutation({
      query: (requests) => ({
        url: "/api/v1/attendance/records/bulk-approve",
        method: "PUT",
        body: requests,
      }),
      invalidatesTags: ["Attendance", "TodayAttendance"],
    }),
    bulkRejectAttendance: builder.mutation({
      query: (requests) => ({
        url: "/api/v1/attendance/records/bulk-reject",
        method: "PUT",
        body: requests,
      }),
      invalidatesTags: ["Attendance", "TodayAttendance"],
    }),

    // ===================== EXPORT ===================== //
    exportAttendance: builder.mutation({
      query: (body) => ({
        url: "/api/v1/attendance/export",
        method: "POST",
        body,
        responseHandler: async (response) => response.blob(),
      }),
    }),
  }),
});
/* ===================== EXPORT HOOKS ===================== */
export const {
  useCheckInMutation,
  useCheckOutMutation,
  useGetAllAttendanceRecordsQuery,
  useGetAttendanceRecordsWithFilterQuery,
  useGetHrAttendanceRecordsQuery,   
  useLazyGetAttendanceByUserIDQuery,
  useGetAttendanceByUserIDQuery,
  useGetMissedCheckoutAlertQuery,
  useGetAttendanceByUserIDAndDateQuery,
  useReviewAttendanceMutation,
  useBulkApproveAttendanceMutation,
  useBulkRejectAttendanceMutation,
  useGetPendingAttendanceRecordsQuery,
  useExportAttendanceMutation,
  useGetRecordsByRoleQuery,
} = attendanceAPI;
